export default "__VITE_ASSET__y5lDaUyL__"